/** MVP-11 #8 — DESIGN §2.3: dark is `:root`, light is `[data-theme="light"]`. Takes the element
 * rather than reading `document` so it is testable without a DOM. */
export function applyDocumentTheme(
  root: { dataset: Record<string, string | undefined> },
  theme: 'dark' | 'light' | null | undefined
): void {
  if (theme === 'light') root.dataset.theme = 'light';
  else delete root.dataset.theme;
}

/** MVP-502 — DESIGN §2.5: the palette axis. `data-palette` is independent of `data-theme`; the
 * house look is the absence of the attribute, so clearing it always lands on `:root` (dark) or
 * `[data-theme='light']`, both of which are gated by `contrast.test.ts`.
 *
 * The fallback is the point of this function, not a tidy-up. Anything that is not the literal
 * 'astryx' — `undefined` on first load, a Strapi field rolled back to an older shape, an enum member
 * added by a future task and shipped to a room running an older bundle — clears the attribute and
 * gets the known-good look. A room PC has no operator standing at it, so there is no way back from a
 * palette that does not exist in this bundle's CSS other than not selecting it in the first place.
 *
 * Takes the element rather than reading `document`, same as `applyDocumentTheme` above. */
export function applyDocumentPalette(
  root: { dataset: Record<string, string | undefined> },
  palette: string | null | undefined
): void {
  if (palette === 'astryx') root.dataset.palette = 'astryx';
  else delete root.dataset.palette;
}
